import Call from '../Call.v2';
import {objToQs} from '../Utils';

const AdkReport = {
    get(type, filters, path = '') {
        return Call(`adk/report/v3/${type}/${path}?${objToQs(filters)}`);
    },
};

export default AdkReport;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkReport.v3.js